export default __webpack_public_path__ + "177bf82ff12a1c471b0bc0c4db9daafc.svg";